
<template>
  <div class="busca-simples-api">
    <Input
      type="text"
      :label="label"
      v-model="busca"
      :disabled="disabled"
      v-debounce:1000ms="handleSearch"
      @input="e => $emit('input', e)"
      class="busca"
      @focus="exibe = true"
      @blur="onBlurBusca"
      iconRight="search"
      :validation="validation"
    />
    <div class="busca-simples-api-lista" v-show="(lista.length > 0 || transicao) && exibe">
      <div class="item" v-if="transicao">{{ this.transicao }}</div>
      <div v-else>
        <div class="item"  v-for="item in lista" :key="item.key" @click="onClick(item)">
          <slot :item="item"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import Input from "./Input";

export default {
  name: "BuscaSimplesApi",
  components: {
    Input
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: [String, Number],
    label: String,
    route: String,
    fieldShow: String,
    fieldSearch: String,
    validation: {
      type: Boolean,
      default: false
    },
    // minDigisToSearch: {
    //   type: [Number, String],
    //   default: 3
    // },
    id: {
      type: String,
      default: null
    }
  },
  watch: {
    value(newVal, oldVal) {
      this.busca = newVal;
    }
  },
  data() {
    return {
      transicao: "",
      busca: "",
      lista: [],
      exibe: false
    };
  },
  methods: {
    handleSearch() {
      this.lista = [];
      // if (this.busca.length < this.minDigisToSearch) {
      // if (this.busca.length) {
      //   this.transicao = "";
      //   return;
      // }
      this.transicao = "Buscando...";
      api(`${this.route}?${this.fieldSearch}=${this.busca}`)
        .then(response => {
          this.lista = [];
          if (response.data.results.length <= 0) {
            this.transicao = "Nenhum encontrado.";
            return;
          }
          for (const key in response.data.results) {
            this.lista.push({ ...response.data.results[key] });
          }
          this.transicao = "";
        })
        .catch(() => {
          this.transicao = "Nenhum encontrado.";
        });
    },
    async onClick(dados) {
      if (typeof dados[this.fieldSearch] === "undefined") {
        return;
      }

      if (this.id) {
        const { data } = await api.get(`${this.route}/${dados[this.id]}`);
        dados = { ...data };
      } else {
        this.lista = [];
        this.busca = "";
      }

      this.$emit("found", dados);
      this.exibe = false;
    },
    onBlurBusca() {
      setTimeout(() => (this.exibe = false), 500);
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/css/blocoBusca.scss";
</style>
